import React from 'react';
import useDisableEnterKey from '../../hooks/useDisableAllKeys';
import * as SOL from "../../styles/solda/StyledComponentSol";

interface ModalYesCloseProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  confirmText?: string;
  text: string;
}

const ModalYesClose: React.FC<ModalYesCloseProps> = ({ isOpen, onClose, onConfirm, confirmText, text }) => {
  useDisableEnterKey(isOpen);
  if (!isOpen) return null;
  return (
    <SOL.ModalOverlay>
      <div className="modal">
        <div className='modal-wrapper'>
          <h3>알림</h3>
          <p className='modal-text'>{text}</p>
          <button className="modal-close-btn" onClick={onClose}>
            닫기
          </button>
          {onConfirm && confirmText && (
            <button className="modal-confirm-btn" onClick={onConfirm}>
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </SOL.ModalOverlay>
  );
};

export default ModalYesClose;
